import React, { useRef, useEffect, useState, useCallback } from 'react';
import "../assets/styles/express.scss"
import Footer from "../components/Footer";
import Header from "../components/Header";
import { FaChevronLeft } from "react-icons/fa";
import { ReactComponent as Umbrella } from '../assets/images/umbrella2.svg';
import { ReactComponent as BarCheck } from '../assets/images/barCheck2.svg';
import { useNavigate } from "react-router-dom";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function Express() {
  const navigate = useNavigate();
  const vipBannerRef = useRef(null);
  const mainContainerRef = useRef(null);
  const mainMain = useRef(null);
  const scaleWrapperRef = useRef(null);
  const [isScaled, setIsScaled] = useState(false);
  const scaleRef = useRef(1);
  const originalBannerHeight = useRef(0);
  const touchStartY = useRef(null);
  const [goftinoReady, setGoftinoReady] = useState(false);


  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount

    document.getElementById('root').style.backgroundColor = 'transparent';
    gsap.registerPlugin(ScrollTrigger);
  
    const bannerBg = vipBannerRef.current;
  
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: scaleWrapperRef.current,
        start: "top top",
        end: "+=900", // increased scroll distance for more scaling
        scrub: true,
      }
    });
  
    tl.to(bannerBg, {
        scale: 3.5, // increased scale for more expansion
        backgroundColor: "#F0E9DD",
        opacity: 1, // optional softness
        ease: "none"
      });
  
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  useEffect(() => {
    const handleGoftinoReady = () => {
      setGoftinoReady(true);
    };

    window.addEventListener('goftino_ready', handleGoftinoReady);

    return () => {
      window.removeEventListener('goftino_ready', handleGoftinoReady);
    };
  }, []);

  const openChat = () => {
      window.Goftino.open();
  
  };
  return (
    <div ref={mainMain} className="express-container">
            <Header/>
    <div className="main-container">
      <div ref={scaleWrapperRef} className="express-banner-wrapper">
  <div className="express-banner-scaler">
    <div ref={vipBannerRef} className="express-banner-bg" />
  </div>

  <div className="express-banner-content">
    <h1>وطن اکسپرس</h1>
    <p>تحویل آنی بار شما در مقصد، بدون نیاز به عملیات پذیرش و معطلی با بسته‌بندی ویژه و حمل توسط خودروی مخصوص.</p>
    <img src={require('../assets/images/expressBannerImg.png')} alt="express banner"/>
  </div>
</div>

        <div ref={mainContainerRef} className="steps-container">
        <div className="steps-header">
            <span>ارسال بار</span>
            <h1>بار شما را با وطن اکسپرس، به ساده‌ترین و سریع‌ترین شکل ارسال می‌کنیم.</h1>
            <p>در این سرویس، مراحل ارسال بار با باربری وطن را برای شما بهبود داده‌ایم و بار شما به‌صورت سفارشی  تنها با طی سه مرحله در مقصد نهایی، تحویل شما یا مشتریان‌تان می‌شود.</p>
        </div>

        <div className="step-container">
            <div className="step-title">یک ۱</div>
            <div className="step-content">
                <img src={require('../assets/images/express1.png')} alt="express step 1"/>
                <div className="step-texts">
                    <div className="text-box">
                        <span>بدون نیاز به مراجعه حضوری</span>
                        <p>پذیرش بار شما در هر نقطه‌ از تهران و حومه همراه با ارائه رسید  و حمل آن به ترمینال مرکزی جهت ارسال اکسپرس به مقصد.</p>
                        <a onClick={openChat} className="expand-btn">
                            <div><FaChevronLeft/></div>
                          ارسال بار با وطن اکسپرس
                        </a>
                    </div>

                    <div className="text-box">
                        <span>در صورت مراجعه حضوری</span>
                        <p>پذیرش بار به‌صورت انحصاری و پذیرایی از شما در سالن مخصوص اکسپرس واقع در ترمینال مرکزی جهت ارسال اکسپرس به مقصد.</p>
                        <a onClick={openChat}  className="expand-btn">
                            <div><FaChevronLeft/></div>
                          آدرس وطن اکسپرس
                        </a>
                    </div>
                </div>
            </div>

            <div className="steps-bg-section">
            <div style={{marginRight:'auto', marginLeft:32, marginTop:96}} className="step-title">دو ۲</div>
            <div className="step-content-two">
            <div className="text-box">
                        <span>عملیات پذیرش بار، بسته‌بندی،‌ صدور رسید و پرداخت کرایه‌شهری</span>
                        <p>تمام این کارها توسط کارکنان قسمت اکسپرس بدون معطلی در ترمینال مرکزی انجام می‌شود تا شما را از انجام این کارها بی‌نیاز کنیم.</p>
                        <button onClick={openChat} className="expand-btn">
                            <div><FaChevronLeft/></div>
                          تماس با وطن اکسپرس
                        </button>
                </div>

                <img src={require('../assets/images/express2.png')} alt="express step 2"/>
            </div>
            <div className="step-two-cards">

            <div className="step-two-card">
                    <div className="img-box">
                    <BarCheck className="img-box-icon"/>
                    </div>
                    <span>بسته‌بندی ویژه بار به‌درخواست شما</span>
                    <p>جهت افزایش امنیت و زیبایی بار و متناسب با نوع بار و درخواست شما در قالب پاکت‌های اختصاصی و ضد‌آب پستی، کارتن‌های اختصاصی همراه با یونولیت و چسب مخصوص و ... .</p>
                </div>

                <div className="step-two-card">
                    <div className="img-box">
                        <Umbrella className="img-box-icon"/>
                    </div>
                    <span>ارسال کالای خاص و حساس</span>
                    <p>از جمله: کالاهای با ارزش بالا، کالاهای الکترونیکی، کالاهای دارویی، کالاهای فاسدشدنی و همچنین محموله‌های پستی  و اسناد و مدارک.</p>
                </div>
            </div>

            <div style={{   marginTop:96}} className="step-title">سه ۳</div>
            <div className="step-three-header">
                <div className="img-box">
                <BarCheck className="img-box-icon"/>
                </div>
                <span>ارسال بار به شعب و نمایندگی‌ها توسط خودروهای مخصوص واحد اکسپرس</span>

                <button onClick={openChat} className="expand-btn">
                            <div><FaChevronLeft/></div>
                          تماس با وطن اکسپرس
                        </button>
            </div>

            <div style={{marginBottom:64}} className="step-content-two">
            <img src={require('../assets/images/express3.png')} alt="express step 3"/>

            <div className="text-box">
                        <span>تحویل آنی بار در مقصد نهایی توسط شعب و نمایندگی‌های انحصاری وطن اکسپرس</span>
                        <p>محموله‌های ارسالی وطن اکسپرس به شعب و نمایندگی‌ها، به‌صورت مجزا و سریع‌تر از محموله‌های ارسالِ عادی در شهر مقصد توزیع می‌‌شود.</p>
                        <button onClick={openChat} className="expand-btn">
                            <div><FaChevronLeft/></div>
رهگیری وضعیت بار                       
 </button>
                </div>

            </div>
            </div>

        </div>
            
        </div>       
    </div>
    <div className="steps-bg-bleed-footer">
      <Footer/>
    </div>
    </div>
  );
}

export default Express;
